import { ref } from 'vue'

import { defineStore } from 'pinia'

export const useBreadcrumbStore = defineStore('retailerBreadcrumb', () => {
  // #region - Pinia State
  const title = ref(null)

  // #region - Pinia Actions
  const setTitle = newTitle => {
    title.value = newTitle
  }

  return {
    title,
    setTitle
  }
})
